<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row dflex">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="new1" (click)='open_detaile(0,1,0)' [disabled]='new_status'>
                    <span>{{ messageService.get_new() }}</span>
                </button>
                <button class="search1" (click)='open_detaile(0,3,0)'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <div class="pager_pe">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,1,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" class='table-scroll mat_table_fa_without_scroll pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:40px' (click)="reset_sort('site_visitor_id','desc')">
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i +
                page_number_first }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'site_visitor_date ' + asc_desc }"
                (click)="sort('site_visitor_date',asc_desc)" style="max-width: 90px;">
                <span>تاریخ</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_visitor_id)"
                style="max-width: 90px;">
                <span>{{ x.site_visitor_date }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status2">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'count ' + asc_desc }"
                (click)="sort('count',asc_desc)" style="max-width: 90px;">
                <span>وضعیت ثبت نام</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_visitor_id)"
                style="max-width: 90px;">
                <span *ngIf="x.count > 0">
                    <mat-icon>check</mat-icon>
                </span>
                <span *ngIf="x.count == 0">-</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="creator">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'creator_title ' + asc_desc }"
                (click)="sort('creator_title',asc_desc)">
                <span>ایجاد کننده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_visitor_id)">
                <div class="right">{{ x.creator_title }}</div>

            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'site_visitor_title ' + asc_desc }"
                (click)="sort('site_visitor_title',asc_desc)">
                <span>نام و نام خانوادگی</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <div class="right fright" (click)="open_detaile(i,2,x.site_visitor_id)">{{ x.site_visitor_title }}</div>
                <span class="left fleft" [matMenuTriggerFor]="menu1" (click)="get_sms(x.site_visitor_cellphone)">
                    <i class="far fa-comments"></i></span>
            </mat-cell>
        </ng-container>
        <mat-menu #menu1="matMenu" class="matMeneVisitor">
            <div class="div_loading">
                <div class="my-container" [hidden]="!loading2">
                    <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
                </div>
            </div>
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr *ngFor="let x of list_sms">
                    <td class="right">{{ x.site_sms_title }}</td>
                    <td (click)="send_sms(x.site_sms_id)" style="min-width: 5rem;" class="cursor">ارسال</td>
                </tr>
            </table>
        </mat-menu>

        <ng-container matColumnDef="company">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'site_visitor_company ' + asc_desc }"
                (click)="sort('site_visitor_company',asc_desc)">
                <span>نام شرکت</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_visitor_id)">
                <span>{{ x.site_visitor_company }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cellphone">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'site_visitor_cellphone ' + asc_desc }"
                (click)="sort('site_visitor_cellphone',asc_desc)">
                <span>شماره همراه</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_visitor_id)">
                <span>{{ x.site_visitor_cellphone }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="state">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'site_state_title ' + asc_desc }"
                (click)="sort('site_state_title',asc_desc)">
                <span>استان</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_visitor_id)">
                <span>{{ x.site_state_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'status_title ' + asc_desc }"
                (click)="sort('status_title',asc_desc)">
                <span>وضعیت</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_visitor_id)">
                <span>{{ x.status_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:50px'>
                <span>عملیات</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:50px'>
                <span (click)="check_access(3,0,x.site_visitor_id,0,1)"><i class="far fa-trash-alt icon"
                        style='margin:0px 4px;'></i></span>
            </mat-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'green':row.count > 0,'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>

    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets//images/preview.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>